import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LocationMarkIcon = function LocationMarkIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "21",
    fill: "none",
    viewBox: "0 0 20 21",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_227_9112)",
      children: /*#__PURE__*/_jsx("path", {
        stroke: "#111827",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5",
        d: "M11.538 15.76l3.385-9.132a.836.836 0 00-1.074-1.074L4.712 8.94c-.77.286-.709 1.395.087 1.595l4.116 1.034 1.028 4.103c.2.797 1.31.858 1.595.088v0z"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_227_9112",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H20V20H0z",
          transform: "translate(0 .5)"
        })
      })
    })]
  });
};